import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { AttachmentsTable } from "core/classes/attachments/attachments.table.class";
import { AttachmentsGallery } from "core/classes/attachments/attachments.gallery.class";
import "core/classes/popups/popup.class";

$(document).ready(function() {
  if (!Abacus.PreventDefault.Attachments) {
    $(document.body).on(
      "click",
      ".attachment-overlay, button.show-fullscreen",
      function(evt) {
        if (Abacus.capableBrowser) {
          evt.preventDefault();
          new Init(this);
        }
      }
    );
  }
});

class Init extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.elementURL =
      this.element.attr("href") || this.element.attr("data-url");
    this.initialLoad();
  }

  initialLoad() {
    var self = this;
    $(window).trigger("abacus:loadPopupContent", [
      {
        element: self.element,
        classes: {
          bodyClass: "popupGalleryActivated"
        },
        popupStyles: {
          klass: "attachments"
        },
        useFixed: true,
        onLoad: function(context) {
          self.initAttachments(context);
        }
      }
    ]);
  }

  initAttachments(context) {
    var self = this;
    this.context = $(context.children().get(0));
    this.getAttachmentType(this.elementURL.match(/attype=([^&]*)/)[1]);
  }

  getAttachmentType(query) {
    switch (query) {
      case "T": // table
        new AttachmentsTable(this.context);
        break;
      default:
        // gallery - handles query = I and G
        new AttachmentsGallery(this.context);
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./Javascript/core/classes/attachments/attachments.class.js